import { render } from "./OrderQuery.vue?vue&type=template&id=57a7a436&ts=true"
import script from "./OrderQuery.vue?vue&type=script&lang=ts"
export * from "./OrderQuery.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__